var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waxon_tm_copyright"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright_inner"})])])}]

export { render, staticRenderFns }